<template>
    <div>
        <div>
            <label class="mt-2">{{$t('table.filter_by_status')}}</label>
            <select style="min-width: 180px;" class="form-control filterBy" v-model="filterByStatus" @change="onFilterByStatus()">
                <option :value="''">{{$t('misc.all')}}</option>
                <option v-for="status in statuses" :value="status.name">{{status.name}}</option>
            </select>
            <data-table
                v-if="tableLoaded"
                :exportable = "false" title=""
                :rows="getData.rowData"
                :columns="columnData"
                :perPage="perPage"
                :rowsCount="rowsCount"
                :currentPage="currentPage"
                :pageCount="pageCount"
                @rowClickDelete="onDeleteRow"
                @rowClickEdit="onEditRow"
                @rowClickCheck="onClickCheck"
                @changePage="changePage"
                @searchEvent="searchEvent"
                @orderByEvent="orderByEvent"
                >
            </data-table>

            <b-btn class="btn btn-dark mt-3 mr-2" @click="goToSubmittal">
                <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.go_to.go_to_submittal')}}
            </b-btn>

            <b-btn class="btn btn-default mt-3" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_messages'], ['create']) && createBtn == true">
                <i class="fa fa-plus-circle mr-1"></i> {{$t('general.administrative.messages.tq.create_button')}}
            </b-btn>
        </div>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="saveModal" :title="actionTitle" size="lg" @ok="saveAction" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_messages'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.tq_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.tq_no">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.tq_title') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.title">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.discipline') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedDiscipline"
                                :options="currentDiscipline"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isDisciplineLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onDisciplineSearch"
                                @input="updateDiscipline"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedDiscipline != null"
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedDiscipline"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="row != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.from_user') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" disabled class="form-control" v-model="row.by_user.fullname">
                        </div>
                    </div>

                    <div class="row mb-3" v-else>
                        <div class="col-lg-4">
                            <label>{{ $t('table.from_user') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" disabled class="form-control" v-model="model.loggedUser">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="specialInputs[0]">
                        <div class="col-lg-4">
                            <label>{{ $t('table.to_company') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedToCompany"
                                :options="currentToCompany"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isToCompanyLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onToCompanySearch"
                                @input="updateToCompany($event, 0)"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedToCompany != null"
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedCompany(0)"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="specialInputs[1]">
                        <div class="col-lg-4">
                            <label>{{ $t('table.to_user') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedUser"
                                :options="currentUser"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isUserLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="fullname" track-by="id"
                                :selectLabel="''"
                                @search-change="onUserSearch"
                                @input="updateUser($event, 1)"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedUser != null"
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedUser(1)"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="specialInputs[2]">
                        <div class="col-lg-4">
                            <label>{{ $t('table.to_working_group') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedToWorkingGroup"
                                :options="currentToWorkingGroup"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isToWorkingGroupLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onToWorkingGroupSearch"
                                @input="updateToWorkingGroup($event, 2)"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedToWorkingGroup != null"
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedToWorkingGroup(2)"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.date_late_response') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.date_late_response"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.description_of_tq') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.description"></textarea>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.priority') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.priority">
                                <option v-for="priority in priorities" :value="priority.name">{{priority.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.submitted_for') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.submitted_for">
                                <option v-for="submitted_for in submitted_for_constant" :value="submitted_for.name">{{submitted_for.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.status') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.status">
                                <option v-for="status in statuses" :value="status.name">{{status.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.scope_change') }}</label>
                        </div>
                        <div class="col-lg-8  mt-2" style="z-index: 0">
                            <toggle-button v-model="model.scope_change" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.cost_impact') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button v-model="model.cost_impact" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.schedule_impact') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button v-model="model.schedule_impact" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.integrity') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button v-model="model.integrity" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.permits_or_authorization') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button v-model="model.permits_or_authorization" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.engineering') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button v-model="model.engineering" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.closed') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0">
                            <toggle-button v-model="model.closed" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.closed == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.closed_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.closed_date"></flat-pickr>
                        </div>
                    </div>

                     <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.answer_required') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.answer_required" :disabled="!this.$store.getters.hasPermission(['project_messages_answers'], ['create'])" :sync="true" :value="false" :color="{checked: '#ff471a'}" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>
                </div>

                <div class="col-lg-12">
                    <hr v-if="(getData.getFiles.length > 0 && hasFilesReadPermission) || hasFilesCreatePermission">
                    <div class="row mt-2" v-if="getData.getFiles.length > 0 && hasFilesReadPermission">
                        <div class="col-lg-12">
                            <label>{{ $t('table.uploaded_files') }}</label>
                        </div>
                        <div class="col-lg-6" v-for="file in getData.getFiles" :key="file.id">
                            <div class="card p-2">
                                <div style="width: 100%; display: block">
                                    <p 
                                        class="float-left customLink" 
                                        @click="onDownloadFile(file.id)" 
                                        :title="file.file_name"
                                    >
                                        {{file.file_name}}
                                    </p>
                                    <p 
                                        v-if="hasFilesDeletePermission"
                                        class="float-right p-0 m-0"
                                    >
                                        <i class='fa fa-2x fa-trash mt-2 text-danger sortable cursor-pointer' @click="onDeleteFile(file.id)"></i>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-2" v-if="hasFilesCreatePermission">
                        <div class="col-lg-12">
                            <div class="row mb-3">
                                <div class="col-lg-12">
                                    <label v-if="row && getData.getFiles.length > 0">{{ $t('table.upload_more_files') }}</label>
                                    <label v-else>{{ $t('table.upload_files') }}</label>
                                </div>
                                <div class="col-lg-12">
                                    <vue-dropzone class="dropzone" ref="document" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12" v-if="row != null && row.answer_required == 1 && this.$store.getters.hasPermission(['project_messages_answers'], ['create'])">
                    <hr>
                    <h3>{{ $t('table.ticket_answers') }}</h3>
                    <data-table
                        :exportable="false" 
                        :search="false" 
                        :paginate="false" title=""
                        :rows="getData.answersData"
                        :columns="answersColumnData"
                        @rowClickEdit="onEditAnswerRow"
                        @rowClickDelete="onDeleteAnswerRow"
                    >
                    </data-table> 
                    <i class="btn pull-right mt-2 fa fa-plus-square fa-2x" style="padding: 0 0 5px 0;" @click="onAddAnswer" v-if="this.$store.getters.hasPermission(['project_messages_answers'], ['create'])"></i>
                </div>
            </div>
        </b-modal>

        <ticket-answer-modal 
            table="pressure_test" 
            :title="actionTitleAnswer" 
            :model.sync="answer_model" 
            ref="ticketAnswerModal" 
            @onDeleteFile="onDeleteTicketAnswerFile"
            @onLoadTable="onLoadTable"
            @onLoadAnswersTable="onLoadAnswersTable"
        >
        </ticket-answer-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitleDelete" @buttonClick="deleteAction">
            {{ deleteMessage }}
        </confirm-dialog>

        <confirm-dialog ref="deleteAnswerModal" :title="actionTitleAnswer" @buttonClick="deleteAnswerAction">
            {{ deleteMessage }}
        </confirm-dialog>

        <confirm-dialog ref="deleteTicketAnswerFileModal" :title="actionTitleDelete" @buttonClick="deleteTicketAnswerFileAction">
            {{ deleteMessage }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import http from '@/libs/http';

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';

import Multiselect from 'vue-multiselect';

import vue2Dropzone from 'vue2-dropzone';
import '@/assets/css/vue2Dropzone.css';

import TicketAnswerModal from '@/components/global/modals/TicketAnswerModal.vue';

export default {
    name: 'tq-table',
    components: {
        DataTable,
        ConfirmDialog,
        notificationIcons,
        Multiselect,
        flatPickr,
        vueDropzone: vue2Dropzone,
        TicketAnswerModal,
    },
    props: {
        createBtn: {
            default: true,
        },
        closed: {
            default: null,
        },
        userId: {
            default: null,
        },
    },
    data() {
        return {
            tableNameTranslated: Vue.i18n.translate('general.administrative.messages.tq.title'),
            tableName: 'ticket',
            row: null,
            isFileDelete: false,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            filterByStatus: '',
            actionTitle: '',
            actionTitleDelete: '',
            actionTitleAnswer: '',
            specialInputs: [true, true, true],
            deleteMessage: '',

            selectedDiscipline: null,
            currentDiscipline: [],
            isDisciplineLoading: false,

            selectedToCompany: null,
            currentToCompany: [],
            isToCompanyLoading: false,

            selectedUser: null,
            currentUser: [],
            isUserLoading: false,

            selectedToWorkingGroup: null,
            currentToWorkingGroup: [],
            isToWorkingGroupLoading: false,

            file_id: null,

            hasFilesReadPermission: false,
            hasFilesCreatePermission: false,
            hasFilesDeletePermission: false,

            dropzoneOptions: {
                url: '/',
                thumbnailWidth: 150,
                addRemoveLinks: true,
                autoProcessQueue: false,
                uploadMultiple: true,
                dictDefaultMessage: '<i class="fa fa-cloud-upload"></i>' + ' ' + Vue.i18n.translate('table.upload_file'),
                maxFiles: 3,
            },
            getData: {
                rowData: [],
                getFiles: [],
                answersData: [],
            },
            model: {
                loggedUser: null,
                is_submittal: 0,
                discipline_id: null,
                to_company_id: null,
                to_user_id: null,
                to_working_group_id: null,
                tq_no: null,
                title: null,
                answer_required: null,
                date_late_response: null,
                description: null,
                submittal_no: null,
                submitted_for: null,
                scope_change: null,
                cost_impact: null,
                schedule_impact: null,
                integrity: null,
                permits_or_authorization: null,
                engineering: null,
                closed_date: null,
                closed: null,
                status: null,
                priority: null,
                file: null,
            },
            answer_model: {
                project_id: null,
                ticket_id: null,
                loggedUser: null,
                answer: null,
                date: null
            },
            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '90px',
                    field: '',
                    showEditButton: true,
                    showDeleteButton: true
                },
                {
                    label: Vue.i18n.translate('table.tq_no'),
                    field: 'tq_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.tq_title'),
                    field: 'title',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.discipline'),
                    field: 'discipline.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.from_user'),
                    field: 'by_user.fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.to_company'),
                    field: 'to_company.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.to_user'),
                    field: 'to_user.fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.to_working_group'),
                    field: 'to_working_group.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.priority'),
                    field: 'priority',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.answer_required'),
                    field: 'answer_required',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                },
                {
                    label: Vue.i18n.translate('table.answers'),
                    field: 'answers',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.cost_impact'),
                    field: 'cost_impact',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                },
                {
                    label: Vue.i18n.translate('table.schedule_impact'),
                    field: 'schedule_impact',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                },
                {
                    label: Vue.i18n.translate('table.status'),
                    field: 'status',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.date_late_response'),
                    field: 'date_late_response',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.closed'),
                    field: 'closed',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                },
                {
                    label: Vue.i18n.translate('table.closed_date'),
                    field: 'closed_date',
                    numeric: false,
                    html: false,
                }
            ],
            answersColumnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '60px',
                    showEditButton: true,
                    showDeleteButton: true
                },
                {
                    label: Vue.i18n.translate('table.user'),
                    width: '130px',
                    field: 'user.fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.answer'),
                    width: '300px',
                    field: 'answer',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.date'),
                    width: '105px',
                    field: 'date',
                    numeric: false,
                    html: false,
                }
            ]
        }
    },
    mounted () {
        this.onLoadTable();

        this.hasFilesReadPermission   = this.$store.getters.hasPermission(['files'], ['read']);
        this.hasFilesCreatePermission = this.$store.getters.hasPermission(['files'], ['create']);
        this.hasFilesDeletePermission = this.$store.getters.hasPermission(['files'], ['delete']);
    },
    computed: {
        submitted_for_constant: {
            get: function () {
                let submitted_for_constant = this.$store.getters.getTicketSubmittedFor;
                return submitted_for_constant;
            }
        },
        priorities: {
            get: function () {
                let priorities = this.$store.getters.getTicketPriorities;
                return priorities;
            }
        },
        statuses: {
            get: function () {
                let statuses = this.$store.getters.getTicketStatuses;
                return statuses;
            }
        }
    },
    watch: {
        submitted_for_constant: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        priorities: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        statuses: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        infoMsg(msg) {
            miniToastr.info(msg, Vue.i18n.translate('messages.info'), 6000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            let data = http.route(this.tableName + '?project_id=' + this.$route.params.id + '&filters[is_submittal]='+this.model.is_submittal+ '&filters[by_user_id]=' + this.userId + '&filters[closed]=' + this.closed + '&filters[status]=' + this.filterByStatus + '&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get();
            data.then(response => {
                if (!response.isError) {
                    this.perPage = response.pagination.limit;
                    this.rowsCount = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount = response.pagination.totalPages;
                    var data = response.data;
                    data.forEach(field => {
                        if (field.by_user == null) {
                            field.by_user = { 'fullname': '' };
                        }

                        if (field.discipline_id == null) {
                            field.discipline = { 'name': '' };
                        }

                        if (field.to_company_id == null) {
                            field.to_company = { 'name': '' };
                        }

                        if (field.to_user_id == null) {
                            field.to_user = { 'fullname': '' };
                        }

                        if (field.to_working_group_id == null) {
                            field.to_working_group = { 'name': '' };
                        }
                    });
                    this.getData.rowData = data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onFilterByStatus () {
            this.onLoadTable();
            this.infoMsg(Vue.i18n.translate('messages.table_filtered'));
        },
        clearSearches () {
            this.selectedDiscipline     = null;
            this.selectedToCompany      = null;
            this.selectedUser           = null;
            this.selectedToWorkingGroup = null;

            this.currentDiscipline     = [];
            this.currentToCompany      = [];
            this.currentUser           = [];
            this.currentToWorkingGroup = [];

            this.getData.getFiles = [];
            this.$nextTick(() => {
                if (typeof this.$refs.document != 'undefined') {
                    this.$refs.document.removeAllFiles();
                }
            });
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.row = null;
            this.clearSearches();

            this.model.loggedUser = this.$store.state.user.user.firstname + ' ' + this.$store.state.user.user.lastname;
            this.specialInputs = [true, true, true];
            this.hideOthers(null, true);

            this.model.title = null;
            this.model.tq_no = null;
            this.model.engineering = null;
            this.model.discipline_id = null;
            this.model.to_company_id = null;
            this.model.to_user_id = null;
            this.model.to_working_group_id = null;
            this.model.submittal_title = null;
            this.model.answer_required = null;
            this.model.date_late_response = this.$options.filters.formatDate(new Date());
            this.model.description = null;
            this.model.submittal_no = null;
            this.model.submitted_for = null;
            this.model.scope_change = null;
            this.model.cost_impact = null;
            this.model.schedule_impact = null;
            this.model.integrity = null;
            this.model.permits_or_authorization = null;
            this.model.closed_date = null;
            this.model.closed = null;
            this.model.status = null;
            this.model.priority = null;

            this.$refs.saveModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.clearSearches();

            if (this.hasFilesReadPermission) {
                this.onViewFiles(this.row.id);
            }

            this.specialInputs = [true, true, true];
            this.model.loggedUser = this.row.by_user.fullname;
            this.onLoadAnswersTable(row.id);
            var array = [this.row.to_company, this.row.to_user, this.row.to_working_group];
            array.forEach((value, key) => {
                if(Object.keys(value).length != 1) {
                    this.hideOthers(key);
                }
            });

            this.model.discipline_id = this.row.discipline_id;
            this.model.engineering = Boolean(this.row.engineering);
            this.model.title = this.row.title;
            this.model.tq_no = this.row.tq_no;
            this.model.to_company_id = this.row.to_company_id;
            this.model.to_user_id = this.row.to_user_id;
            this.model.to_working_group_id = this.row.to_working_group_id;
            this.model.submittal_title = this.row.submittal_title;
            this.model.answer_required = Boolean(this.row.answer_required);
            this.model.date_late_response = this.row.date_late_response;
            this.model.description = this.row.description;
            this.model.submittal_no = this.row.submittal_no;
            this.model.submitted_for = this.row.submitted_for;
            this.model.scope_change = Boolean(this.row.scope_change);
            this.model.cost_impact = Boolean(this.row.cost_impact);
            this.model.schedule_impact = Boolean(this.row.schedule_impact);
            this.model.integrity = Boolean(this.row.integrity);
            this.model.permits_or_authorization = Boolean(this.row.permits_or_authorization);
            this.model.closed_date = this.row.closed_date;
            this.model.closed = Boolean(this.row.closed);
            this.model.status = this.row.status;
            this.model.priority = this.row.priority;

            this.selectedDiscipline     = (this.row.discipline != null && typeof this.row.discipline.name != 'undefined' && this.row.discipline.name != '') ? this.row.discipline : null;
            this.selectedUser           = (this.row.to_user != null && typeof this.row.to_user.fullname != 'undefined' && this.row.to_user.fullname != '') ? this.row.to_user : null;
            this.selectedToCompany      = (this.row.to_company != null && typeof this.row.to_company.name != 'undefined' && this.row.to_company.name != '') ? this.row.to_company : null;
            this.selectedToWorkingGroup = (this.row.to_working_group != null && typeof this.row.to_working_group.name != 'undefined' && this.row.to_working_group.name != '') ? this.row.to_working_group : null;

            this.$refs.saveModal.show();
        },
        saveAction (e) {
            e.preventDefault();

            let put_data = {
                is_submittal: this.model.is_submittal,
                project_id: this.$route.params.id,
                discipline_id: this.model.discipline_id,
                to_company_id: this.model.to_company_id,
                to_user_id: this.model.to_user_id,
                to_working_group_id: this.model.to_working_group_id,
                title: this.model.title,
                tq_no: this.model.tq_no,
                answer_required: this.model.answer_required,
                date_late_response: this.model.date_late_response,
                description: this.model.description,
                submittal_no: this.model.submittal_no,
                submitted_for: this.model.submitted_for,
                scope_change: this.model.scope_change,
                cost_impact: this.model.cost_impact,
                schedule_impact: this.model.schedule_impact,
                integrity: this.model.integrity,
                permits_or_authorization: this.model.permits_or_authorization,
                engineering: this.model.engineering,
                closed_date: this.model.closed_date,
                closed: this.model.closed,
                status: this.model.status,
                priority: this.model.priority,
            }

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            if (this.row) {
                let data = http.route(this.tableName + '/' + this.row.id).patch(put_data, true);
                data.then(response => {
                    if (response.isError == false) {
                        var hasCorrectPermission = this.$store.getters.hasPermission(['project_messages_answers'], ['read', 'create']);
                        if ((this.row.answer_required != put_data.answer_required) && put_data.answer_required == 1 && hasCorrectPermission) {
                            this.infoMsg(Vue.i18n.translate('messages.can_add_answer') + ' ' + this.tableNameTranslated + '.');
                        }
                        if ((this.row.closed != put_data.closed) && put_data.closed == 1) {
                            this.infoMsg(this.tableNameTranslated + ' ' + Vue.i18n.translate('messages.is_closed'));
                        } else if ((this.row.closed != put_data.closed) && put_data.closed == 0) {
                            this.infoMsg(this.tableNameTranslated + ' ' + Vue.i18n.translate('messages.is_open'));
                        }
                        this.$refs.saveModal.hide();
                        this.uploadDocuments(this.row.id);
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else {
                let data = http.route(this.tableName).post(put_data, true);
                data.then(response => {
                    if (response.isError == false) {
                        if (put_data.answer_required == 1) {
                            this.infoMsg(Vue.i18n.translate('messages.can_add_answer') + ' ' + Vue.i18n.translate('general.administrative.messages.tq.title') + '.');
                        }
                        if (put_data.closed == 1) {
                            this.infoMsg(Vue.i18n.translate('general.administrative.messages.tq.title') + ' ' + Vue.i18n.translate('messages.is_closed'));
                        }
                        this.$refs.saveModal.hide();
                        this.uploadDocuments(response.data.id);
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
        uploadDocuments (id) {
            if (this.hasFilesCreatePermission && typeof this.$refs.document != 'undefined') { 
                var file = this.$refs.document.getQueuedFiles();
                for (let order = 0; order < file.length; order++) {
                    var formData = new FormData();
                    formData.append('file', file[order]);
                    formData.append('type', 'ticket');
                    formData.append('ticket_id', id);
                    formData.append('project_id', this.$route.params.id);
                    let data = http.route('file').post(
                        formData,
                            {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    ).then(response => {
                        if(response.data == false) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            this.successMsg(Vue.i18n.translate('messages.file_uploaded'));
                        }
                    });
                }
            }
        },
        onViewFiles (id) {
            this.getData.getFiles.length = 0;
            let data = http.route('file?filters[ticket_id]=' + id).get();
            data.then(response => {
                if(response.data == false) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.getData.getFiles = response.data;
                }
            });
        },
        onDownloadFile (id) {
            let data = http.route('file/' + id).get(
            {
                export_pdf: 1
            }, true);
            data.then(response => {
                if (!response.isError) {
                    this.successMsg(Vue.i18n.translate('messages.file.file_download'));
                    let data = http.route('get_content/file/'+response.data.id+'/'+response.data.file_name).downloadPdf({}, response.data.file_name).then(res => {});
                } else {
                    this.errorMsg(Vue.i18n.translate('messages.file.error_download'));
                }
            });
        },
        onDeleteRow (row, index) {
            this.actionTitleDelete = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.deleteMessage = Vue.i18n.translate('messages.delete');
            this.row = row;
            this.file_id = null;
            this.isFileDelete = false;
            this.$refs.deleteModal.show();
        },
        onDeleteFile (id) {
            this.actionTitleDelete = Vue.i18n.translate('messages.delete_file_title');
            this.deleteMessage = Vue.i18n.translate('messages.delete_file');
            this.file_id = id;
            this.isFileDelete = true;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                if (this.isFileDelete == true) {
                    let data = http.route('file/' + this.file_id).delete();
                    data.then(response => {
                        if (!response.isError) {
                            this.onLoadTable();
                            this.successMsg(Vue.i18n.translate('messages.deleted_file_message'));
                            this.file_id = null;
                            this.$refs.saveModal.hide();
                        } else {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        }
                    });
                } else if (this.isFileDelete == false) {
                    let data = http.route(this.tableName + '/' + this.row.id).delete();
                    data.then(response => {
                        if (!response.isError) {
                            if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                                this.currentPage = this.currentPage - 1;
                            }

                            this.onLoadTable();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                }
            }

            if (this.file == true && button == 0) {
                this.$refs.saveModal.show();
            }
            this.$refs.deleteModal.hide();
        },
        hideOthers (to_ignore, showAll = false) {
            for (let i = 0; i < 3; i++) {
                if (showAll) {
                    this.specialInputs[i] = true;
                } else {
                    if(i != to_ignore) {
                        this.specialInputs[i] = false;
                    }
                }
            };
        },
        onClickCheck (row, index, column) {
            if (row) {
                this.model[column.toString()] = (row[column.toString()] == null || row[column.toString()] == 0) ? 1 : 0;

                var clone = Object.assign({}, row);
                clone[column.toString()] = !clone[column.toString()];

                let data = http.route(this.tableName + '/' + row.id).patch(clone, true);
                data.then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        row[column.toString()] = !row[column.toString()];
                        this.onLoadTable();
                        if (column == 'closed') {
                            if (clone.closed == 1) {
                                this.infoMsg(this.tableNameTranslated + ' ' + Vue.i18n.translate('messages.is_closed'));
                            } else {
                                this.infoMsg(this.tableNameTranslated + ' ' + Vue.i18n.translate('messages.is_open'));
                            }
                        } else {
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        }
                    }
                });
                this.model[column.toString()] = null;
            }
        },
        goToSubmittal() {
            this.$router.push('/project/'+this.$route.params.id+'/administrative/messages/submittal');
        },
        //Ticket Answers
        onLoadAnswersTable(id) {
            http.route('ticket_answer?project_id=' + this.$route.params.id + '&filters[ticket_id]=' + id).get().then(response => {
                if (!response.isError) {
                    var data = response.data;
                    this.getData.answersData = data;
                }
            });
        },
        onAddAnswer() {
            this.actionTitleAnswer = Vue.i18n.translate('modal.general.create') + ' ' + Vue.i18n.translate('table.answer');
            this.$refs.ticketAnswerModal.clear();
            this.answer_model.ticket_id = this.row.id;
            this.answer_model.date = this.$options.filters.formatDate(new Date());
            this.$refs.ticketAnswerModal.show();
        },
        onEditAnswerRow(row) {
            this.actionTitleAnswer = Vue.i18n.translate('modal.general.edit') + ' ' + Vue.i18n.translate('table.answer');
            this.rowAnswer = row;
            this.$refs.ticketAnswerModal.clear();
            this.$refs.ticketAnswerModal.onViewTicketFile(row.id);
            this.answer_model.id = row.id;
            this.answer_model.ticket_id = row.ticket_id;
            this.answer_model.loggedUser = row.user.fullname;
            this.answer_model.answer = row.answer;
            this.answer_model.date = row.date;
            this.$refs.ticketAnswerModal.show();
        },
        onDeleteAnswerRow(row) {
            this.actionTitleAnswer = Vue.i18n.translate('modal.general.delete') + ' ' + Vue.i18n.translate('table.answer');
            this.rowAnswer = row;
            this.deleteMessage = Vue.i18n.translate('messages.delete');
            this.$refs.deleteAnswerModal.show();
        },
        deleteAnswerAction(button) {
            if(button == 1) {
                http.route('ticket_answer/' + this.rowAnswer.id).delete().then(response => {
                    if (!response.isError) {
                        this.onLoadTable();
                        this.onLoadAnswersTable(this.row.id);
                        this.successMsg(Vue.i18n.translate('table.answer') + ' ' + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteAnswerModal.hide();
        },
        onDeleteTicketAnswerFile (id) {
            this.actionTitleDelete = Vue.i18n.translate('messages.delete_file_title');
            this.deleteMessage = Vue.i18n.translate('messages.delete_file');
            this.file_id = id;
            this.$refs.deleteTicketAnswerFileModal.show();
        },
        deleteTicketAnswerFileAction (button) {
            if (button == 1) {
                let data = http.route('file/' + this.file_id).delete();
                data.then(response => {
                    if (!response.isError) {
                        this.onLoadTable();
                        this.file_id = null;
                        this.$refs.ticketAnswerModal.onViewTicketFile(this.rowAnswer.id);
                        this.successMsg(Vue.i18n.translate('messages.deleted_file_message'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteTicketAnswerFileModal.hide();
        },
        onDisciplineSearch(search) {
            if (search == '') {
                this.currentDiscipline = [];
                
                return false;
            }

            this.isDisciplineLoading = true;
            this.searchDiscipline(search, this);
        },
        searchDiscipline: _.debounce((search, vm) => {
            let data = http.route('discipline?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentDiscipline = response.data;
                }
                vm.isDisciplineLoading = false;
            });
        }, 500),
        updateDiscipline(discipline) {
            this.model.discipline_id = (discipline != null) ? discipline.id : null;
        },
        clearSelectedDiscipline () {
            this.selectedDiscipline  = null;
            this.model.discipline_id = null;
        },
        onToCompanySearch(search) {
            if (search == '') {
                this.currentToCompany = [];
                
                return false;
            }

            this.isToCompanyLoading = true;
            this.searchToCompany(search, this);
        },
        searchToCompany: _.debounce((search, vm) => {
            let data = http.route('company?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentToCompany = response.data;
                }
                vm.isToCompanyLoading = false;
            });
        }, 500),
        updateToCompany(to_company, id) {
            this.model.to_company_id = (to_company != null) ? to_company.id : null;            
            this.hideOthers(id, (to_company == null));
        },
        clearSelectedCompany (id) {
            this.selectedToCompany   = null;
            this.model.to_company_id = null;
            this.hideOthers(id, true);
        },
        onUserSearch(search) {
            if (search == '') {
                this.currentUser = [];
                
                return false;
            }

            this.isUserLoading = true;
            this.searchUser(search, this);
        },
        searchUser: _.debounce((search, vm) => {
            let data = http.route('user/getall?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentUser = response.data;
                }
                vm.isUserLoading = false;
            });
        }, 500),
        updateUser(user, id) {
            this.model.to_user_id = (user != null) ? user.id : null;
            this.hideOthers(id, (user == null));
        },
        clearSelectedUser (id) {
            this.selectedUser     = null;
            this.model.to_user_id = null;
            this.hideOthers(id, true);
        },
        onToWorkingGroupSearch(search) {
            if (search == '') {
                this.currentToWorkingGroup = [];
                
                return false;
            }

            this.isToWorkingGroupLoading = true;
            this.searchToWorkingGroup(search, this);
        },
        searchToWorkingGroup: _.debounce((search, vm) => {
            let data = http.route('team?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentToWorkingGroup = response.data;
                }
                vm.isToWorkingGroupLoading = false;
            });
        }, 500),
        updateToWorkingGroup(to_working_group, id) {
            this.model.to_working_group_id = (to_working_group) ? to_working_group.id : null;
            this.hideOthers(id, (to_working_group == null));
        },
        clearSelectedToWorkingGroup (id) {
            this.selectedToWorkingGroup    = null;
            this.model.to_working_group_id = null;
            this.hideOthers(id, true);
        },
    }
}
</script>

<style scoped>
    select {
        -webkit-appearance:menulist-button;
        -moz-appearance:menulist-button;
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/pages/project/administrative/ticket/tq/tq_table.vue